import styles from "../styles/Footer.module.css";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function Footer() {
  const { t } = useTranslation(["Footer"]);
  return (
    <div className={styles.footerContainer}>
      <div className={styles.content}>
        <div className={styles.colsContainer}>
          <div className={styles.logoCol}>
            <img src="/bidd_logo.svg" alt="bidd-logo" width="160" height="40" />
            <div className={styles.slogan}>
              <p>bidd@bidd.is</p>
              <p>610223-0440</p>
            </div>
          </div>
        </div>
        <div className={styles.divider}></div>
        <div className={styles.bottomBar}>
          <div className={styles.leftSection}>
            <div className={styles.copyRightText}>
              © {new Date().getFullYear()} Bidd. {t("rightsReserved")}
            </div>
            <Link to="/terms-and-conditions" className={styles.termsLink}>
              {t("termsAndConditions")}
            </Link>
          </div>
          <div className={styles.iconsContainer}>
            <img
              src="/logos/facebook_logo_footer.svg"
              alt="facebook"
              width="24"
              height="24"
            />
            <img
              src="/logos/linkedIn_logo_footer.svg"
              alt="linkedIn"
              width="24"
              height="24"
            />
            <img
              src="/logos/insta_logo_footer.svg"
              alt="instagram"
              width="24"
              height="24"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
